import { useBlocker } from 'react-router-dom';

export default function Prompt({
  when,
  message,
}: {
  when: boolean;
  message: string;
}) {
  useBlocker(() => {
    if (when) {
      return !window.confirm(message);
    }
    return false;
  });

  return <div key={when.toString()} />;
}
